import { withMeta } from '@/helpers/dataLayer';
import { lockModal, unLockModal } from '@/utils/helpers';

export default {
  props: {
    bodyClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    clickOutsideEnabled: {
      type: Boolean,
      default: false,
    },
    gtm: [String, Object],
    fullScreen: {
      type: Boolean,
      default: false,
    },
    overlayTheme: {
      type: String,
      default: 'default',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    overlayClassModifiers() {
      return {
        modal__overlay: true,
        [`modal__overlay--${this.overlayTheme}`]: this.overlayTheme,
      };
    },
    classModifier() {
      return {
        'modal__content--full': this.fullScreen,
        'modal__content--no-padding': this.noPadding,
      };
    },
  },
  methods: {
    hasHeader() {
      return !!this.$slots.header && !this.hideHeader;
    },
    hasFooter() {
      return !!this.$slots.footer;
    },
    close() {
      if (this.gtm && this.gtm.closing) {
        this.$gtm.trackEvent(withMeta(this.gtm.closing));
      }
      this.$emit('modalClose');
    },
    onClickOutside() {
      if (this.clickOutsideEnabled) this.close();
    },
    afterEnter() {},
  },
  created() {
    lockModal();
    if (this.gtm) {
      const name =
        this.gtm.virtualPage || (typeof this.gtm === 'string' ? this.gtm : this.gtm.name);
      const virtualPage = this.gtm.virtualPage ? name : `${this.$route.path}/${name}`;

      if (virtualPage) {
        this.$gtm.trackEvent(
          withMeta({
            event: 'pageviewTrackerEvent',
            virtualPage,
            virtualPageTitle: `modal/${name}`,
          }),
        );
      }
    }
  },
  beforeUnmount() {
    if (this.gtm && this.$route && this.$route.fullPath) {
      this.$gtm.trackEvent(
        withMeta({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.fullPath,
          virtualPageTitle: this.$route.name,
          closing: this.gtm,
        }),
      );
    }
    unLockModal();
  },
};
